/**
 * Sparkline - the mini trend line used inside benchmark/futures cards.
 * Extracted verbatim from the public Commodities page so internal cards
 * render the identical treatment. `dataKey` defaults to 'close' (the shape
 * of both price feeds); pass `height` to deviate from the 40px standard.
 */
import React from 'react';
import { Box } from '@mui/material';
import { AreaChart, Area, YAxis, ResponsiveContainer } from 'recharts';

function Sparkline({ data, color, id, dataKey = 'close', height = 40 }) {
  // Sanitised, because this id is referenced back as url(#...) and an SVG
  // reference cannot contain a comma, a space or a percent sign. Callers pass
  // whatever identifies the row, and a series label like "Rice, Thailand 5%"
  // silently broke the reference: the gradient failed to resolve and the area
  // rendered as flat grey while every other card looked right.
  const gradientId = `spark-${String(id ?? 'x').replace(/[^A-Za-z0-9_-]/g, '-')}`;
  return (
    <Box sx={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.16} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <YAxis hide domain={['dataMin', 'dataMax']} />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={1.6}
            fill={`url(#${gradientId})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default Sparkline;
